import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

class Vacancy {
    constructor() {
        this.request = document.querySelectorAll('.vacancy-request');
        if (!this.request.length) return false;

        this.shareLinks = document.querySelectorAll('.vacancy-share__button');
        this.events();
    }

    events() {
        this.request.forEach(request => request.addEventListener('click', this.setPositionName.bind(this)))
        if (this.shareLinks.length) {
            this.shareLinks.forEach(link => link.addEventListener('click', this.setShareLinks.bind(this)))
        }
    }

    setPositionName(e) {
        const modalPositionName = document.querySelector('.vacancy-modal__name');
        const formPositionField = document.querySelector('.gf-vacancy__position input');
        modalPositionName.textContent = e.target.dataset.vacancyTitle;
        formPositionField.value = e.target.dataset.vacancyTitle;
    }

    setShareLinks(e) {
        const vacancy = e.target.closest('[data-vacancy]');

        document.querySelector('.vacancy-share__list [data-whatsapp]').href = vacancy.dataset.whatsapp;
        document.querySelector('.vacancy-share__list [data-twitter]').href = vacancy.dataset.twitter;
        document.querySelector('.vacancy-share__list [data-facebook]').href = vacancy.dataset.facebook;
        document.querySelector('.vacancy-share__list [data-vk]').href = vacancy.dataset.vk;
        document.querySelector('.vacancy-share__list [data-ok]').href = vacancy.dataset.ok;
        document.querySelector('.vacancy-share__list [data-linkedin]').href = vacancy.dataset.linkedin;

    }
}

export default Vacancy;
